import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-res-user2",
  "use": "oc-res-user2-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"oc-res-user2\"><path fill=\"#6B7180\" d=\"M13.5 9.5a2 2 0 0 1 2 2v5h-13v-5a2 2 0 0 1 2-2h9Zm0 1.5h-9a.5.5 0 0 0-.492.41L4 11.5V15h10v-3.5a.5.5 0 0 0-.41-.492L13.5 11ZM9 1.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7ZM9 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol